import { useEffect } from "react"
import { ICardFieldProps } from "../cards/CardField"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ImagePrimitive } from "../../primitive"
import { defaultPrimitive, ILandingPrimitive, MedallionCardField } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */ 
const CardFieldMedallion = (props: ICardFieldProps): JSX.Element => {
    const { value, section, i } = props
    const field: MedallionCardField = props.field as MedallionCardField

    const radius = getCssDemention(field.radius, "40px")  
    const borderRadius = getCssDemention(field.borderRadius || field.radius / 2, "40px")
    const halfRadius = getCssDemention(field.radius / 2, "40px")
    const radius2 = getCssDemention((field.radius - field.margin * 2), "40px")
    const radius2Hover = getCssDemention((field.radius - field.margin * 2 + field.hover_size), "40px")
    const halfRadius2 = getCssDemention(field.borderRadius || (field.radius - field.margin) / 2, "40px")
    const margin = getCssDemention(field.margin, "0")
 
    useEffect(() => {
      
        addCSSClass(
            `landing-card-field-${section.id + "-" + value.id}`,
            `.landing-card-field-${section.id} {
                width: ${radius}!important;
                height: ${radius}!important; 
                transform: translateX(-${halfRadius})!important;
                top: -${halfRadius}!important;
                background-color: ${field.color}!important;
                ${ field.isSquare ? `border-radius: 1px!important;` : borderRadius }
            }
            .landing-medallion-icon-${ section.id + "-" + value.id } { 
                margin: ${ margin }!important;
                width: ${ radius2 }!important;
                height: ${ radius2 }!important;
                background-size: ${ radius2 }!important;
                border-radius: ${ field.isSquare ? 1 : halfRadius2 }!important;  
                background-image: url(${ value.data  || field.icon });
                &:hover {
                    background-size: ${ radius2Hover }!important;
                }
            }
            .landing-medallion-icon-${ section.id + "-" + value.id }:hover {
                background-size: ${ radius2Hover }!important;
            }
            `
        )
        return () => removeCSSClass(`landing-card-field-${section.id} + "-" + props.value.id`)
    }, []) 
    
    const primitive: ILandingPrimitive = {
            ...defaultPrimitive(),
            ...field,
            ...value, 
            data: {
                src_type: "div",
                ...field.data,
                src: value.data,
                className : `landing-medallion-icon landing-medallion-icon-${ section.id + "-" + value.id }`,
            },
            position: {
                width : radius,
                height : radius 
            },
            style: { ...field.style, ...value.style },
            id: section.id + "-" + value?.id,
        } 

    return <div 
        className={`landing-card-field landing-card-field-medallion ${value?.className || ""} h-0`}
        style={{ height:0 }}  
        data-card-field-id={i}
        card-field-section-id={section.id} 
    >
        <div className={`landing-medallion landing-card-field-${section.id}`} style={{ ...field.style, ...value.style }}> 
            <ImagePrimitive 
                primitive={primitive as any}
            />
        </div>
    </div>
}
export default CardFieldMedallion